import { render, staticRenderFns } from "./RadioDesigner.vue?vue&type=template&id=0b36df06&scoped=true&"
import script from "./RadioDesigner.vue?vue&type=script&lang=js&"
export * from "./RadioDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b36df06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b36df06')) {
      api.createRecord('0b36df06', component.options)
    } else {
      api.reload('0b36df06', component.options)
    }
    module.hot.accept("./RadioDesigner.vue?vue&type=template&id=0b36df06&scoped=true&", function () {
      api.rerender('0b36df06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/formField/RadioDesigner.vue"
export default component.exports